import { get } from '@/api/general';

export default {
  list: () => get('options'),
  values: (optionId) => get(`options/${optionId}/values`),
};
